import { getAuth } from 'firebase/auth';
import { client } from 'src/graphql/client';

export const logoutHelper = async (
  redirect: boolean = true,
): Promise<void | string> => {
  const auth = getAuth();
  sessionStorage.removeItem('@control-plane/service-key-id');
  auth.signOut();
  await client.clearStore();
  if (redirect) {
    return (window.location.href = '/login');
  }

  return;
};
